// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__kd1ba","primaryBtn":"button_primaryBtn__586uv","secondaryBtn":"button_secondaryBtn__254iy"};